import { render, staticRenderFns } from "./ExpensesView.vue?vue&type=template&id=51412fa3&"
import script from "./ExpensesView.vue?vue&type=script&lang=js&"
export * from "./ExpensesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports